




















































































import { Component, Vue } from 'vue-property-decorator'
import SupplierPane from '@/components/material/supplier-pane.vue'
import ExportData from '@/components/export-data/index.vue'
import { RequestPaging } from '@/utils/util'
import { apiSupplierList } from '@/api/material'

@Component({
  components: {
    SupplierPane,
    ExportData
  }
})
export default class Supplier extends Vue {
    queryObj: any = {
      keyword: '',
      supplier_type: '',
      cooperation_status: ''
    }

    supplierTypeList: any[] = [
      { value: '1', label: '保洁用品' },
      { value: '2', label: '维修材料' },
      { value: '3', label: '布草清洗' },
      { value: '4', label: '设备配件' },
      { value: '5', label: '办公用品' },
      { value: '6', label: '食品饮料' },
      { value: '7', label: '其他' }
    ]

    tabCount = {
      all_count: 0,
      cooperation_count: 0,
      suspended_count: 0,
      terminated_count: 0
    }

    pager = new RequestPaging()
    activeName: any = 'all'
    activeStatus: any = ''

    // 映射tab名称到状态值
    getStatusByTabName (tabName: string): string {
      const map: any = {
        all: '',
        cooperation: '1',
        suspended: '2',
        terminated: '3'
      }
      return map[tabName] || ''
    }

    getList (page?: number): void {
      this.activeStatus = this.getStatusByTabName(this.activeName)
      page && (this.pager.page = page)

      const params = {
        ...this.queryObj,
        cooperation_status: this.activeStatus
      }

      this.pager
        .request({
          callback: apiSupplierList,
          params: params
        })
        .then((res: any) => {
          this.tabCount = res?.extend
        })
    }

    handleReset () {
      this.queryObj = {
        keyword: '',
        supplier_type: '',
        cooperation_status: ''
      }
      this.getList(1)
    }

    handleAdd () {
      this.$router.push('/material/supplier_add')
    }

    handleExport () {
      // 导出功能实现
      this.$message.info('导出功能待开发')
    }

    created () {
      this.getList()
    }

    activated () {
      this.getList()
    }
}
